module.exports = __webpack_public_path__ + "img/18a.be424425.png";